import hero from '@propertypal/shared/src/resources/bg/dev-websites-header.jpg';
import axios, { API_URL } from '@propertypal/shared/src/services/axios';
import { AgentShowcase } from '@propertypal/shared/src/types/agentShowcase';
import platform from '@propertypal/shared/src/utils/platform';
import { GetServerSideProps, GetServerSidePropsContext } from 'next';
import Head from 'next/head';
import React from 'react';
import { Dispatch } from 'redux';
import BespokeDesign from '../../../components/development-microsites/BespokeDesign';
import Bespoke from '../../../components/estate-agent-websites/Bespoke';
import Customers from '../../../components/estate-agent-websites/Customers';
import FeaturedContent from '../../../components/estate-agent-websites/FeaturedContent';
import FeaturesSection from '../../../components/estate-agent-websites/FeaturesSection';
import GetInTouch from '../../../components/estate-agent-websites/GetInTouch';
import SuperFeature from '../../../components/estate-agent-websites/SuperFeature';
import TemplateWebsites from '../../../components/estate-agent-websites/TemplateWebsites';
import generateMetaTags from '../../../components/layout/MetaTags';
import { requireAuthToken } from '../../../utils/auth';

interface Props {
  data: AgentShowcase | null;
}

const metaData = {
  title: `Developer Websites - ${platform.title}`,
  description: 'Showcase Development Websites.',
  url: `/products/developers/developer-websites`,
};

const getAgentDetails = async (dispatch: Dispatch, ctx?: GetServerSidePropsContext) => {
  try {
    const result = await axios<AgentShowcase>(
      {
        method: 'GET',
        url: `${API_URL}/agent-microsite-showcase/developers?logoLocator=400x400:FILL_CROP`,
      },
      dispatch,
      ctx,
    );
    return result.data;
  } catch (err: any) {
    return null;
  }
};

export const getServerSideProps: GetServerSideProps = requireAuthToken(async (ctx, store) => {
  const data = await getAgentDetails(store.dispatch, ctx);

  return {
    props: {
      data,
    },
  };
});

const DeveloperWebsites: React.FC<Props> = ({ data }) => {
  return (
    <>
      <Head>{generateMetaTags(metaData)}</Head>

      <SuperFeature hero={hero} subHeadingMaxW={360} />
      <FeaturedContent dev />
      <FeaturesSection dev />
      <Bespoke dev />
      <TemplateWebsites dev />
      <BespokeDesign />
      <Customers dev data={data?.microsites} />
      <GetInTouch />
    </>
  );
};

export default DeveloperWebsites;
